export default "__VITE_ASSET__SCU6mvOi__"